import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { toCurrency } from "../utils/Convert";
import TaxPicker from "./TaxPicker";
import LoadList from "../load/LoadList";
import { api } from "../utils/Api";
import InvoicePicker from "./InvoicePicker";
import DiscountPicker from "./DiscountPicker";
import SpinnerButton from "../layout/SpinnerButton";

const JobToInvoiceModal = ({ jobId, pcb, history }) => {
	const [customer, setCustomer] = useState("");
	const [customerName, setCustomerName] = useState("");
	const [job, setJob] = useState("");
	const [invoiceAddress, setInvoiceAddress] = useState("");
	const [stateTax, setStateTax] = useState(0);
	const [countyTax, setCountyTax] = useState(0);
	const [taxAmount, setTaxAmount] = useState(0);
	const [invoiceTax, setInvoiceTax] = useState({
		label: "State",
		value: "state",
	});
	const [invoiceDate, setInvoiceDate] = useState("");
	const [unitPrice, setUnitPrice] = useState(0);
	const [paymentTerm, setPaymentTerm] = useState("7");
	const [psi, setPsi] = useState("");
	const [psiDescription, setPsiDescription] = useState("");
	const [quantity, setQuantity] = useState(0);
	const [loadList, setLoadList] = useState([]);
	const [amount, setAmount] = useState(0);
	const [fuelSurcharge, setFuelSurcharge] = useState(true);
	const [fuelRate, setFuelRate] = useState(25);
	const [trips, setTrips] = useState(0);
	const [isCreditCardPayment, setIsCreditCardPayment] = useState(false);
	const [creditCardFee, setCreditCardFee] = useState(4);
	const [factoring, setFactoring] = useState(false);
	const [applyDiscount, setApplyDiscount] = useState(false);
	const [discount, setDiscount] = useState(0);
	const [discountAmount, setDiscountAmount] = useState(0);
	const [discountReason, setDiscountReason] = useState("");
	const [po, setPO] = useState("");
	const [invoiceNumber, setInvoiceNumber] = useState("");
	const [invoiceTotal, setInvoiceTotal] = useState(0);
	const [invoiceExists, setInvoiceExists] = useState(false);
	const [invoiceID, setInvoiceID] = useState("");
	const [shipping, setShipping] = useState(true);
	const [shippingRate, setShippingRate] = useState(0);
	const [color, setColor] = useState(false);
	const [colorTicket, setColorTicket] = useState(0);
	const [fiber, setFiber] = useState(false);
	const [fiberBags, setFiberBags] = useState(0);
	const [size, setSize] = useState(false);
	const [sizeBags, setSizeBags] = useState(0);
	const [miscelaneos, setMiscelaneos] = useState(false);
	const [miscelaneosFee, setMiscelaneosFee] = useState(0);
	const [miscelaneosReason, setMiscelaneosReason] = useState("");
	const [invoiceType, setInvoiceType] = useState({
		value: "total",
		label: "Total",
	});
	const [discountType, setDiscountType] = useState({
		value: "percentageAfter",
		label: "Percentage (%) After Taxes",
	});
	const [subtotal, setSubtotal] = useState(0);
	const [creditCardCost, setCreditCardCost] = useState(0);
	const [isTotal, setIsTotal] = useState(true);
	const [productList, setProductList] = useState([]);
	const [fuelSurchargeGlobal, setFuelSurchargeGlobal] = useState(false);
	const [shippingGlobal, setShippingGlobal] = useState(false);
	const [colorGlobal, setColorGlobal] = useState(false);
	const [fiberGlobal, setFiberGlobal] = useState(false);
	const [sizeGlobal, setSizeGlobal] = useState(false);
	const [miscelaneosGlobal, setMiscelaneosGlobal] = useState(false);
	const [energyConsumption, setEnergyConsumption] = useState(false);
	const [energyConsumptionFee, setEnergyConsumptionFee] = useState(0);
	const [energyConsumptionGlobal, setEnergyConsumptionGlobal] = useState(false);
	const [timeSurcharge, setTimeSurcharge] = useState(false);
	const [timeSurchargeFee, setTimeSurchargeFee] = useState(0);
	const [timeSurchargeGlobal, setTimeSurchargeGlobal] = useState(false);
	const [lightSurcharge, setLightSurcharge] = useState(false);
	const [lightSurchargeFee, setLightSurchargeFee] = useState(0);
	const [lightSurchargeGlobal, setLightSurchargeGlobal] = useState(false);
	const [iceSurcharge, setIceSurcharge] = useState(false);
	const [iceSurchargeFee, setIceSurchargeFee] = useState(0);
	const [iceSurchargeGlobal, setIceSurchargeGlobal] = useState(false);
	const [readyMixTruckRentalService, setReadyMixTruckRentalService] =
		useState(false);
	const [readyMixTruckRentalServiceFee, setReadyMixTruckRentalServiceFee] =
		useState(0);
	const [
		readyMixTruckRentalServiceGlobal,
		setReadyMixTruckRentalServiceGlobal,
	] = useState(false);
	const [readyMixDriver, setReadyMixDriver] = useState(false);
	const [readyMixDriverFee, setReadyMixDriverFee] = useState(0);
	const [readyMixDriverGlobal, setReadyMixDriverGlobal] = useState(false);
	const [plantStandBy, setPlantStandBy] = useState(false);
	const [plantStandByFee, setPlantStandByFee] = useState(0);
	const [plantStandByGlobal, setPlantStandByGlobal] = useState(false);
	const [environmentalChargePerLoad, setEnvironmentalChargePerLoad] =
		useState(false);
	const [environmentalChargePerLoadFee, setEnvironmentalChargePerLoadFee] =
		useState(0);
	const [
		environmentalChargePerLoadGlobal,
		setEnvironmentalChargePerLoadGlobal,
	] = useState(false);

	const [franchise, setFranchise] = useState("57Concrete");

	const shipRef = useRef(0);
	const fuelRef = useRef(25);
	const discountRef = useRef(0);
	const creditRef = useRef(4);
	const colorRef = useRef(0);
	const fiberRef = useRef(0);
	const sizeRef = useRef(0);
	const miscelaneosRef = useRef(0);
	const energyConsumptionRef = useRef(0);
	const timeRef = useRef(0);
	const lightRef = useRef(0);
	const iceRef = useRef(0);
	const plantRef = useRef(0);
	const environmentRef = useRef(0);
	const readyMixTruckRef = useRef(0);
	const readyMixDriverRef = useRef(0);
	const totalsPerTicket = useRef({});
	const loading = useRef(true);

	useEffect(() => {
		// getCompanyInfo();
		getInvoiceExistance();
		getJobInfo();
		loading.current = false;
	}, []);

	useEffect(() => {
		getInvoiceInfo();
		loading.current = false;
	}, [invoiceID, invoiceExists]);

	/**
	 * Check if the invoice exists
	 */
	const getInvoiceExistance = async () => {
		const url = api + "/jobinvoice/" + jobId;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			setInvoiceID(data._id);
			setInvoiceExists(true);
		} catch (err) {
			setInvoiceExists(false);
			return null;
		}
	};

	/**
	 * Get company information
	 */
	const getCompanyInfo = async (franchise) => {
		const url = api + "/company";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			setStateTax(franchise === "Castle" ? 0.0825 : data.stateTax);
			setCountyTax(franchise === "Castle" ? 0.0825 : data.countyTax);
		} catch (err) {
			console.error(err);
			return null;
		}
	};

	/**
	 * Get job information
	 */
	const getJobInfo = async () => {
		const url = api + "/job/" + jobId;
		const urlPsiList = api + "/psi/list/57Concrete";
		const urlLoad = api + "/load/" + jobId;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		const reqJob = await axios.get(url);
		const reqList = await axios.get(urlPsiList);
		const reqLoad = await axios.get(urlLoad);

		axios
			.all([reqJob, reqList, reqLoad])
			.then(
				axios.spread((...responses) => {
					const job = responses[0].data;
					const resList = responses[1].data;
					const loadList = responses[2].data;
					setTrips(loadList.length);

					// Product description
					const found = resList.find((item) => item.psi === job.psi);
					const description = found ? found.description : job.psi;
					setPsiDescription(description);
					setProductList(resList);

					// Customer id and name
					setCustomer(job.customer._id);
					setCustomerName(
						job.customer.customerNumber + " " + job.customer.name,
					);

					// Job attributes
					setJob(job._id);
					setInvoiceDate(job.scheduledDate);
					setUnitPrice(job.unitPrice);
					setPsi(job.psi);
					setPO(job.po);
					setInvoiceAddress(job.shipAddress);
					setFuelRate(job.fuelSurcharge);
					setTimeSurchargeFee(job.timeSurcharge);
					setLightSurchargeFee(job.lightSurcharge);
					setIceSurchargeFee(job.iceSurcharge);
					setReadyMixTruckRentalServiceFee(job.readyMixTruckRentalService);
					setReadyMixDriverFee(job.readyMixDriver);
					setPlantStandByFee(job.plantStandBy);
					setEnvironmentalChargePerLoadFee(job.environmentalChargePerLoad);
					setShippingRate(job.deliveryFee ? job.deliveryFee : 0);
					setFuelSurchargeGlobal(job.fuelSurchargeGlobal);
					setTimeSurchargeGlobal(job.timeSurchargeGlobal);
					setLightSurchargeGlobal(job.lightSurchargeGlobal);
					setIceSurchargeGlobal(job.iceSurchargeGlobal);
					setReadyMixTruckRentalServiceGlobal(
						job.readyMixTruckRentalServiceGlobal,
					);
					setReadyMixDriverGlobal(job.readyMixDriverGlobal);
					setPlantStandByGlobal(job.plantStandByGlobal);
					setEnvironmentalChargePerLoadGlobal(
						job.environmentalChargePerLoadGlobal,
					);
					setShippingGlobal(job.shippingGlobal);

					shipRef.current = job.deliveryFee;
					fuelRef.current = job.fuelSurcharge;
					timeRef.current = job.timeSurcharge;
					lightRef.current = job.lightSurcharge;
					iceRef.current = job.iceSurcharge;
					readyMixTruckRef.current = job.readyMixTruckRentalService;
					readyMixDriverRef.current = job.readyMixDriver;
					plantRef.current = job.plantStandBy;
					environmentRef.current = job.environmentalChargePerLoad;

					getCompanyInfo(job.franchise || "57Concrete");
					setFranchise(job.franchise || "57Concrete");

					// Obtiene el numero de folio de la factura
					setLoadList(loadList);
					setInvoiceNumber(`2${job.number}`); // 2 + job._id

					// calculator
					const totalLoad = loadList.reduce((acc, load) => acc + load.yards, 0);
					setQuantity(totalLoad);
					const materialAmount = totalLoad * job.unitPrice;
					setAmount(materialAmount);
				}),
			)
			.catch((errors) => {
				console.error(errors.message);
				return null;
			});
	};

	/**
	 * Post job
	 */
	const postJob = async () => {
		const job = {
			shipAddress: invoiceAddress,
			fuelSurcharge: fuelRate,
			timeSurcharge: timeSurchargeFee,
			lightSurcharge: lightSurchargeFee,
			iceSurcharge: iceSurchargeFee,
			readyMixTruckRentalService: readyMixTruckRentalServiceFee,
			readyMixDriver: readyMixDriverFee,
			plantStandBy: plantStandByFee,
			environmentalChargePerLoad: environmentalChargePerLoadFee,
			deliveryFee: shippingRate,
			fuelSurchargeGlobal: fuelSurchargeGlobal,
			timeSurchargeGlobal: timeSurchargeGlobal,
			lightSurchargeGlobal: lightSurchargeGlobal,
			iceSurchargeGlobal: iceSurchargeGlobal,
			readyMixTruckRentalServiceGlobal: readyMixTruckRentalServiceGlobal,
			readyMixDriverGlobal: readyMixDriverGlobal,
			plantStandByGlobal: plantStandByGlobal,
			environmentalChargePerLoadGlobal: environmentalChargePerLoadGlobal,
			shippingGlobal: shippingGlobal,
			psi: psi,
			updatedBy: localStorage.getItem("userId"),
		};

		const url = api + "/job/" + jobId;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			await axios.patch(url, job);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	/**
	 * Get invoice information
	 */
	const getInvoiceInfo = async () => {
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
		if (invoiceExists) {
			try {
				const urlGet = api + `/invoice/${invoiceID}`;
				const { data } = await axios.get(urlGet);
				setColor(data.color);
				setColorTicket(data.colorTicket);
				setFiber(data.fiber);
				setFiberBags(data.fiberBags);
				setSize(data.size);
				setSizeBags(data.sizeBags);
				setFuelSurcharge(data.fuelSurcharge);
				setTimeSurcharge(data.timeSurcharge);
				setLightSurcharge(data.lightSurcharge);
				setIceSurcharge(data.iceSurcharge);
				setReadyMixTruckRentalService(data.readyMixTruckRentalService);
				setReadyMixDriver(data.readyMixDriver);
				setPlantStandBy(data.plantStandBy);
				setEnvironmentalChargePerLoad(data.environmentalChargePerLoad);
				setTimeSurchargeFee(data.timeSurchargeFee);
				setLightSurchargeFee(data.lightSurchargeFee);
				setIceSurchargeFee(data.iceSurchargeFee);
				setReadyMixTruckRentalServiceFee(data.readyMixTruckRentalServiceFee);
				setReadyMixDriverFee(data.readyMixDriverFee);
				setPlantStandByFee(data.plantStandByFee);
				setEnvironmentalChargePerLoadFee(data.environmentalChargePerLoadFee);
				setShipping(data.shipping);
				setCreditCardFee(data.creditCardFee);
				setIsCreditCardPayment(data.isCreditCardPayment);
				setMiscelaneos(data.miscelaneos);
				setMiscelaneosFee(data.miscelaneosFee);
				setMiscelaneosReason(data.miscelaneosReason);
				setApplyDiscount(data.isDiscount);
				setDiscountAmount(data.discountAmount);
				setDiscountReason(data.discountReason);
				setPaymentTerm(data.paymentTerm);
				setDiscount(data.discount === 0 ? data.discountAmount : data.discount);
				setDiscountType(
					data.discountType === null || data.discountType === undefined
						? { value: "amountAfter", label: "Amount ($) After Taxes" }
						: data.discountType === "percentageAfter"
							? {
									value: "percentageAfter",
									label: "Percentage (%) After Taxes",
								}
							: data.discountType === "percentageBefore"
								? {
										value: "percentageBefore",
										label: "Percentage (%) Before Taxes",
									}
								: data.discountType === "amountAfter"
									? { value: "amountAfter", label: "Amount ($) After Taxes" }
									: { value: "amountBefore", label: "Amount ($) Before Taxes" },
				);
				setIsTotal(data.isTotal);
				setInvoiceType(
					data.isTotal
						? { value: "total", label: "Total" }
						: { value: "tickets", label: "Per Tickets" },
				);
				setFactoring(data.factoring);
				setEnergyConsumption(
					data.energyConsumption ? data.energyConsumption : false,
				);
				setEnergyConsumptionFee(
					data.energyConsumptionFee ? data.energyConsumptionFee : 0,
				);

				setColorGlobal(data.colorGlobal);
				setFiberGlobal(data.fiberGlobal);
				setSizeGlobal(data.sizeGlobal);
				setMiscelaneosGlobal(data.miscelaneosGlobal);
				setEnergyConsumptionGlobal(
					data.energyConsumptionGlobal ? data.energyConsumptionGlobal : false,
				);
				setTimeSurchargeGlobal(
					data.timeSurchargeGlobal ? data.timeSurchargeGlobal : false,
				);
				setLightSurchargeGlobal(
					data.lightSurchargeGlobal ? data.lightSurchargeGlobal : false,
				);
				setIceSurchargeGlobal(
					data.iceSurchargeGlobal ? data.iceSurchargeGlobal : false,
				);
				setReadyMixTruckRentalServiceGlobal(
					data.readyMixTruckRentalServiceGlobal
						? data.readyMixTruckRentalServiceGlobal
						: false,
				);
				setReadyMixDriverGlobal(
					data.readyMixDriverGlobal ? data.readyMixDriverGlobal : false,
				);
				setPlantStandByGlobal(
					data.plantStandByGlobal ? data.plantStandByGlobal : false,
				);
				setEnvironmentalChargePerLoadGlobal(
					data.environmentalChargePerLoadGlobal
						? data.environmentalChargePerLoadGlobal
						: false,
				);

				discountRef.current = data.discount;
				creditRef.current = data.creditCardFee;
				colorRef.current = data.colorTicket;
				fiberRef.current = data.fiberBags;
				sizeRef.current = data.sizeBags;
				miscelaneosRef.current = data.miscelaneosFee;
				energyConsumptionRef.current = data.energyConsumptionFee
					? data.energyConsumptionFee
					: 0;
				timeRef.current = data.timeSurchargeFee ? data.timeSurchargeFee : 0;
				lightRef.current = data.lightSurchargeFee ? data.lightSurchargeFee : 0;
				iceRef.current = data.iceSurchargeFee ? data.iceSurchargeFee : 0;
				readyMixTruckRef.current = data.readyMixTruckRentalServiceFee
					? data.readyMixTruckRentalServiceFee
					: 0;
				readyMixDriverRef.current = data.readyMixDriverFee
					? data.readyMixDriverFee
					: 0;
				plantRef.current = data.plantStandByFee ? data.plantStandByFee : 0;
				environmentRef.current = data.environmentalChargePerLoadFee
					? data.environmentalChargePerLoadFee
					: 0;
			} catch (err) {
				console.error(err);
				return null;
			}
		}
	};

	/**
	 * Post load
	 * @param {Object} ticket current delivery ticket
	 */
	const postLoad = async (ticket) => {
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		const load = {
			fuelSurcharge: ticket.fuelSurcharge,
			fuelRate: ticket.fuelRate,
			shipping: ticket.shipping,
			shippingFee: ticket.shippingFee,
			color: ticket.color,
			colorTicket: ticket.colorTicket,
			fiber: ticket.fiber,
			fiberBags: ticket.fiberBags,
			size: ticket.size,
			sizeBags: ticket.sizeBags,
			miscelaneos: ticket.miscelaneos,
			miscelaneosFee: ticket.miscelaneosFee,
			miscelaneosReason: ticket.miscelaneosReason
				? ticket.miscelaneosReason
				: "",
			energyConsumption: ticket.energyConsumption,
			energyConsumptionFee: ticket.energyConsumptionFee,
			timeSurcharge: ticket.timeSurcharge,
			timeSurchargeFee: ticket.timeSurchargeFee,
			lightSurcharge: ticket.lightSurcharge,
			lightSurchargeFee: ticket.lightSurchargeFee,
			iceSurcharge: ticket.iceSurcharge,
			iceSurchargeFee: ticket.iceSurchargeFee,
			readyMixTruckRentalService: ticket.readyMixTruckRentalService,
			readyMixTruckRentalServiceFee: ticket.readyMixTruckRentalServiceFee,
			readyMixDriver: ticket.readyMixDriver,
			readyMixDriverFee: ticket.readyMixDriverFee,
			plantStandBy: ticket.plantStandBy,
			plantStandByFee: ticket.plantStandByFee,
			environmentalChargePerLoad: ticket.environmentalChargePerLoad,
			environmentalChargePerLoadFee: ticket.environmentalChargePerLoadFee,
		};

		try {
			const urlPatch = api + `/load/${ticket._id}`;
			await axios.patch(urlPatch, load);
		} catch (err) {
			console.error(err);
			return null;
		}
	};

	/**
	 * Save changes of each load list
	 */
	const onSaveLoadsChanges = () => {
		loadList.map((load) => {
			postLoad(load);
		});
	};

	/**
	 * Change quantity of yards
	 * @param {Event} e event of the input
	 */
	const changeQuantity = (e) => {
		const totalLoad = e.target.value;
		setQuantity(totalLoad);
		setAmount(totalLoad * unitPrice);
		invoiceType.value === "total"
			? calculateTax(invoiceTax.value)
			: calculateTotals();
	};

	/**
	 * Change tax type
	 * @param {Object} selectedTax current selected tax
	 */
	const onChangeTax = (selectedTax) => {
		const impuesto = selectedTax.value;
		setInvoiceTax(selectedTax);
		invoiceType.value === "total" ? calculateTax(impuesto) : calculateTotals();
	};

	/**
	 * Change invoice type
	 * @param {Object} selectedInvoice current selected invoice
	 */
	const onChangeInvoice = (selectedInvoice) => {
		const invoice = selectedInvoice.value;
		setInvoiceType(selectedInvoice);
		setIsTotal((prevValue) => !prevValue);

		if (invoice !== "total") {
			fuelRef.current = 0;
			shipRef.current = 0;
			setCreditCardCost(0);
			colorRef.current = 0;
			fiberRef.current = 0;
			sizeRef.current = 0;
			miscelaneosRef.current = 0;
			energyConsumptionRef.current = 0;
			timeRef.current = 0;
			lightRef.current = 0;
			iceRef.current = 0;
			readyMixTruckRef.current = 0;
			readyMixDriverRef.current = 0;
			plantRef.current = 0;
			environmentRef.current = 0;
			calculateTotals();
		} else {
			fuelRef.current = fuelRate;
			shipRef.current = shippingRate;
			colorRef.current = colorTicket;
			fiberRef.current = fiberBags;
			sizeRef.current = sizeBags;
			miscelaneosRef.current = miscelaneosFee;
			energyConsumptionRef.current = energyConsumptionFee;
			timeRef.current = timeSurchargeFee;
			lightRef.current = lightSurchargeFee;
			iceRef.current = iceSurchargeFee;
			readyMixTruckRef.current = readyMixTruckRentalServiceFee;
			readyMixDriverRef.current = readyMixDriverFee;
			plantRef.current = plantStandByFee;
			environmentRef.current = environmentalChargePerLoadFee;
			calculateTax(invoiceTax.value, discountType.value, invoice);
		}
	};

	/**
	 * Change discount type
	 * @param {Object} selectedDiscount current selected invoice
	 */
	const onChangeDiscount = (selectedDiscount) => {
		const type = selectedDiscount.value;
		setDiscountType(selectedDiscount);
		invoiceType.value === "total"
			? calculateTax(invoiceTax.value, type)
			: calculateTotals();
	};

	/**
	 * This event occurs only when at least one of the values inside []
	 */
	useEffect(() => {
		if (invoiceType.value === "total") {
			calculateTax(invoiceTax.value);
		} else {
			calculateTotals();
		}
	}, [
		fuelSurcharge,
		timeSurcharge,
		lightSurcharge,
		iceSurcharge,
		readyMixTruckRentalService,
		readyMixDriver,
		plantStandBy,
		environmentalChargePerLoad,
		shipping,
		isCreditCardPayment,
		discount,
		color,
		fiber,
		size,
		miscelaneos,
		energyConsumption,
		applyDiscount,
		amount,
		fuelSurchargeGlobal,
		shippingGlobal,
		colorGlobal,
		fiberGlobal,
		sizeGlobal,
		miscelaneosGlobal,
		energyConsumptionGlobal,
		timeSurchargeGlobal,
		lightSurchargeGlobal,
		iceSurchargeGlobal,
		readyMixTruckRentalServiceGlobal,
		readyMixDriverGlobal,
		plantStandByGlobal,
		environmentalChargePerLoadGlobal,
		stateTax,
		countyTax,
	]);

	/**
	 * Calculate totals for invoice type 'Per Tickets'
	 */
	const calculateTotals = () => {
		let tripCharge = 0;
		let shippingFee = 0;
		let colorFee = 0;
		let fiberFee = 0;
		let sizeFee = 0;
		let miscelaneosFee = 0;
		let energyConsumptionFee = 0;
		let timeSurchargeFee = 0;
		let lightSurchargeFee = 0;
		let iceSurchargeFee = 0;
		let readyMixTruckRentalServiceFee = 0;
		let readyMixDriverFee = 0;
		let plantStandByFee = 0;
		let environmentalChargePerLoadFee = 0;

		loadList.map((load) => {
			if (load.fuelSurcharge) tripCharge += load.fuelRate;
			if (load.shipping) shippingFee += load.shippingFee;
			if (load.color) colorFee += load.colorTicket * 50;
			if (load.fiber) fiberFee += load.fiberBags * 20;
			if (load.size) sizeFee += load.sizeBags * 20;
			if (load.miscelaneos) miscelaneosFee += load.miscelaneosFee;
			if (load.energyConsumption)
				energyConsumptionFee += load.energyConsumptionFee;
			if (load.timeSurcharge) timeSurchargeFee += load.timeSurchargeFee;
			if (load.lightSurcharge) lightSurchargeFee += load.lightSurchargeFee;
			if (load.iceSurcharge) iceSurchargeFee += load.iceSurchargeFee;
			if (load.readyMixTruckRentalService)
				readyMixTruckRentalServiceFee += load.readyMixTruckRentalServiceFee;
			if (load.readyMixDriver) readyMixDriverFee += load.readyMixDriverFee;
			if (load.plantStandBy) plantStandByFee += load.plantStandByFee;
			if (load.environmentalChargePerLoad)
				environmentalChargePerLoadFee += load.environmentalChargePerLoadFee;
		});

		totalsPerTicket.current = {
			tripCharge: tripCharge,
			shippingFee: shippingFee,
			colorFee: colorFee,
			fiberFee: fiberFee,
			sizeFee: sizeFee,
			miscelaneosFee: miscelaneosFee,
			energyConsumptionFee: energyConsumptionFee,
			timeSurchargeFee: timeSurchargeFee,
			lightSurchargeFee: lightSurchargeFee,
			iceSurchargeFee: iceSurchargeFee,
			readyMixTruckRentalServiceFee: readyMixTruckRentalServiceFee,
			readyMixDriverFee: readyMixDriverFee,
			plantStandByFee: plantStandByFee,
			environmentalChargePerLoadFee: environmentalChargePerLoadFee,
		};
		calculateTax();
	};

	/**
	 * Tax and total calculator
	 * @param {Object} impuesto current tax type selected
	 * @param {Object} type current discount type selected
	 * @param {Object} invoice current invoice type selected
	 */
	const calculateTax = (
		impuesto = invoiceTax.value,
		type = discountType.value,
		invoice = invoiceType.value,
	) => {
		let taxPercentaje = 0;
		switch (impuesto) {
			case "state":
				taxPercentaje = stateTax;
				break;
			case "county":
				taxPercentaje = countyTax;
				break;
			case "exempt":
				taxPercentaje = 0;
				break;
			default:
				taxPercentaje = stateTax;
		}

		let subtotal = amount;

		if (invoice === "total") {
			if (fuelSurcharge) {
				if (fuelSurchargeGlobal) {
					subtotal += parseFloat(fuelRef.current);
				} else {
					subtotal += parseFloat(fuelRef.current * trips);
				}
			}
			if (shipping) {
				if (shippingGlobal) {
					subtotal += parseFloat(shipRef.current);
				} else {
					subtotal += parseFloat(shipRef.current * trips);
				}
			}
			if (color) {
				if (colorGlobal) {
					subtotal += parseFloat(colorRef.current);
				} else {
					subtotal += parseFloat(colorRef.current * trips);
				}
			}
			if (fiber) {
				if (fiberGlobal) {
					subtotal += parseFloat(fiberRef.current);
				} else {
					subtotal += parseFloat(fiberRef.current * trips);
				}
			}
			if (size) {
				if (sizeGlobal) {
					subtotal += parseFloat(sizeRef.current);
				} else {
					subtotal += parseFloat(sizeRef.current * trips);
				}
			}
			if (miscelaneos) {
				if (miscelaneosGlobal) {
					subtotal += parseFloat(miscelaneosRef.current);
				} else {
					subtotal += parseFloat(miscelaneosRef.current * trips);
				}
			}
			if (energyConsumption) {
				if (energyConsumptionGlobal) {
					subtotal += parseFloat(energyConsumptionRef.current);
				} else {
					subtotal += parseFloat(energyConsumptionRef.current * trips);
				}
			}
			if (timeSurcharge) {
				if (timeSurchargeGlobal) {
					subtotal += parseFloat(timeRef.current);
				} else {
					subtotal += parseFloat(timeRef.current * trips);
				}
			}
			if (lightSurcharge) {
				if (lightSurchargeGlobal) {
					subtotal += parseFloat(lightRef.current);
				} else {
					subtotal += parseFloat(lightRef.current * trips);
				}
			}
			if (iceSurcharge) {
				if (iceSurchargeGlobal) {
					subtotal += parseFloat(iceRef.current);
				} else {
					subtotal += parseFloat(iceRef.current * trips);
				}
			}
			if (readyMixTruckRentalService) {
				if (readyMixTruckRentalServiceGlobal) {
					subtotal += parseFloat(readyMixTruckRef.current);
				} else {
					subtotal += parseFloat(readyMixTruckRef.current * trips);
				}
			}
			if (readyMixDriver) {
				if (readyMixDriverGlobal) {
					subtotal += parseFloat(readyMixDriverRef.current);
				} else {
					subtotal += parseFloat(readyMixDriverRef.current * trips);
				}
			}
			if (plantStandBy) {
				if (plantStandByGlobal) {
					subtotal += parseFloat(plantRef.current);
				} else {
					subtotal += parseFloat(plantRef.current * trips);
				}
			}
			if (environmentalChargePerLoad) {
				if (environmentalChargePerLoadGlobal) {
					subtotal += parseFloat(environmentRef.current);
				} else {
					subtotal += parseFloat(environmentRef.current * trips);
				}
			}
			if (isCreditCardPayment) {
				let tarjeta =
					parseFloat(subtotal) * (parseFloat(creditRef.current) / 100.0);
				subtotal += parseFloat(tarjeta);
				setCreditCardCost(tarjeta);
			}
		} else {
			subtotal += totalsPerTicket.current.tripCharge;
			subtotal += totalsPerTicket.current.shippingFee;
			subtotal += totalsPerTicket.current.colorFee;
			subtotal += totalsPerTicket.current.fiberFee;
			subtotal += totalsPerTicket.current.sizeFee;
			subtotal += totalsPerTicket.current.miscelaneosFee;
			subtotal += totalsPerTicket.current.energyConsumptionFee;
			subtotal += totalsPerTicket.current.timeSurchargeFee;
			subtotal += totalsPerTicket.current.lightSurchargeFee;
			subtotal += totalsPerTicket.current.iceSurchargeFee;
			subtotal += totalsPerTicket.current.readyMixTruckRentalServiceFee;
			subtotal += totalsPerTicket.current.readyMixDriverFee;
			subtotal += totalsPerTicket.current.plantStandByFee;
			subtotal += totalsPerTicket.current.environmentalChargePerLoadFee;
		}

		setSubtotal(subtotal);

		let taxes = 0;
		let suma = 0;

		if (applyDiscount) {
			if (type === "percentageAfter") {
				taxes = subtotal * taxPercentaje;
				suma = subtotal + taxes;
				let descuento =
					parseFloat(suma) * (parseFloat(discountRef.current) / 100.0);
				suma -= descuento;
				setDiscountAmount(descuento);
			} else if (type === "percentageBefore") {
				let descuento =
					parseFloat(subtotal) * (parseFloat(discountRef.current) / 100.0);
				taxes = subtotal * taxPercentaje;
				suma = subtotal - descuento + taxes;
				setDiscountAmount(descuento);
			} else if (type === "amountAfter") {
				taxes = subtotal * taxPercentaje;
				suma = subtotal + taxes;
				let descuento = discountRef.current;
				suma -= descuento;
				setDiscountAmount(descuento);
			} else if (type === "amountBefore") {
				let descuento = discountRef.current;
				suma = subtotal - descuento;
				taxes = suma * taxPercentaje;
				suma += taxes;
				setDiscountAmount(descuento);
			}
		} else {
			setDiscountAmount(0);
			setDiscount(0);
			taxes = subtotal * taxPercentaje;
			suma = subtotal + taxes;
		}

		setTaxAmount(taxes);
		setInvoiceTotal(suma);
	};

	/**
	 * Post new invoice
	 */
	const postInvoice = async () => {
		const url = api + "/invoice";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
		const invoice = {
			customer,
			job,
			psi,
			psiDescription,
			invoiceNumber,
			invoiceCustomerName: customerName,
			invoiceAddress,
			invoiceTax: invoiceTax.value,
			invoiceDate,
			paymentTerm,
			quantity,
			rate: unitPrice,
			amount,
			taxAmount,
			fuelSurcharge,
			fuelRate: !fuelSurcharge ? 0 : fuelRate,
			isCreditCardPayment,
			creditCardFee: !isCreditCardPayment ? 0 : creditCardFee,
			creditCardCost: !isCreditCardPayment ? 0 : creditCardCost,
			factoring,
			isDiscount: applyDiscount,
			discount: !applyDiscount ? 0 : discountRef.current,
			discountReason: !applyDiscount ? "" : discountReason,
			discountAmount: !applyDiscount ? 0 : discountAmount,
			discountType: !applyDiscount ? null : discountType.value,
			invoiceTotal,
			shipping,
			shippingFee: !shipping ? 0 : shippingRate,
			color,
			colorTicket: !color ? 0 : colorTicket,
			fiber,
			fiberBags: !fiber ? 0 : fiberBags,
			size,
			sizeBags: !size ? 0 : sizeBags,
			miscelaneos,
			miscelaneosFee: !miscelaneos ? 0 : miscelaneosFee,
			miscelaneosReason: !miscelaneos ? "" : miscelaneosReason,
			energyConsumption,
			energyConsumptionFee: !energyConsumption ? 0 : energyConsumptionFee,
			timeSurcharge,
			timeSurchargeFee: !timeSurcharge ? 0 : timeSurchargeFee,
			lightSurcharge,
			lightSurchargeFee: !lightSurcharge ? 0 : lightSurchargeFee,
			iceSurcharge,
			iceSurchargeFee: !iceSurcharge ? 0 : iceSurchargeFee,
			readyMixTruckRentalService,
			readyMixTruckRentalServiceFee: !readyMixTruckRentalService
				? 0
				: readyMixTruckRentalServiceFee,
			readyMixDriver,
			readyMixDriverFee: !readyMixDriver ? 0 : readyMixDriverFee,
			plantStandBy,
			plantStandByFee: !plantStandBy ? 0 : plantStandByFee,
			environmentalChargePerLoad,
			environmentalChargePerLoadFee: !environmentalChargePerLoad
				? 0
				: environmentalChargePerLoadFee,
			isTotal,
			fuelSurchargeGlobal,
			shippingGlobal,
			colorGlobal,
			fiberGlobal,
			sizeGlobal,
			miscelaneosGlobal,
			energyConsumptionGlobal,
			timeSurchargeGlobal,
			lightSurchargeGlobal,
			iceSurchargeGlobal,
			readyMixTruckRentalServiceGlobal,
			readyMixDriverGlobal,
			plantStandByGlobal,
			environmentalChargePerLoadGlobal,
		};

		if (invoiceExists) {
			// Delete values not allowed to update
			delete invoice.customer;
			delete invoice.job;
			delete invoice.invoiceNumber;
			delete invoice.invoiceCustomerName;
			delete invoice.invoiceDate;

			try {
				const urlPatch = api + `/invoice/${invoiceID}`;
				await axios.patch(urlPatch, invoice);
			} catch (err) {
				console.error(err);
				return null;
			}
		} else {
			// No invoice has been created
			try {
				await axios.post(url, invoice);
			} catch (err) {
				console.error(err.message);
				return null;
			}
		}
	};

	/**
	 * Save changes of the inputs
	 * @param {Event} e event of the input
	 */
	const submit = (e) => {
		e.preventDefault();
		loading.current = true;
		postInvoice();
		postJob();
		if (invoiceType.value === "tickets") onSaveLoadsChanges();
		loading.current = false;
		pcb();
	};

	const InvoiceForm = () => (
		<form className="form" onSubmit={submit}>
			<div className="form-group row">
				<div className="col-sm-4">
					<label className="text-muted">Ship Date</label>
					<input
						type="text"
						className="form-control"
						value={new Date(invoiceDate).toLocaleDateString()}
						readOnly
					/>
				</div>
				<div className="col-sm-4">
					<label className="text-muted">Tax</label>
					<TaxPicker action={onChangeTax} value={invoiceTax} />
				</div>
				<div className="col-sm-4">
					<label className="text-muted">Rate</label>
					<input
						type="text"
						className="form-control"
						style={{ textAlign: "right" }}
						value={toCurrency(unitPrice, 2)}
						readOnly
					/>
				</div>
			</div>
			<div className="form-group row">
				<div className="col-sm-6">
					<label className="text-muted">Quantity</label>
					<input
						type="number"
						className="form-control"
						style={{ textAlign: "right" }}
						value={quantity}
						onChange={changeQuantity}
					/>
				</div>
				<div className="col-sm-6">
					<label className="text-muted">Material</label>
					<input
						style={{ textAlign: "right" }}
						type="text"
						className="form-control"
						value={toCurrency(amount, 2)}
						readOnly
					/>
				</div>
			</div>
			<div className="form-group row">
				<div className="col-sm-6">
					<label className="text-muted">Invoice Type</label>
					<InvoicePicker action={onChangeInvoice} value={invoiceType} />
				</div>
			</div>
			<div
				className="form-group row"
				hidden={invoiceType.value === "tickets" ? true : false}
			>
				<div className="col-sm-6">
					<input
						name="fuelSurcharge"
						type="checkbox"
						checked={fuelSurcharge}
						onChange={(e) => setFuelSurcharge((prevValue) => !prevValue)}
					/>
					<label>&nbsp;Standar Fuel Surcharge</label>
				</div>
			</div>
			{fuelSurcharge && (
				<div
					className="form-group row"
					hidden={invoiceType.value === "tickets" ? true : false}
				>
					<div className="col-sm-4 d-flex justify-content-center">
						<input
							name="fuelSurchargeGlobal"
							type="checkbox"
							checked={fuelSurchargeGlobal}
							onChange={(e) =>
								setFuelSurchargeGlobal((prevValue) => !prevValue)
							}
						/>
						<label className="mt-auto mb-auto">&nbsp;Apply To Global</label>
					</div>
					<div className="col-sm-4">
						<label className="text-muted">Fee</label>
						<input
							name="FuelRate"
							type="number"
							className="form-control"
							value={fuelRate}
							onChange={(e) => {
								setFuelRate(e.target.value);
								fuelRef.current = e.target.value ? e.target.value : 0;
								calculateTax();
							}}
						/>
					</div>
					<div className="col-sm-4">
						<label className="text-muted">Trip charge</label>
						<input
							name="tripTotal"
							style={{ textAlign: "right" }}
							className="form-control"
							readOnly
							value={toCurrency(trips * fuelRate, 2)}
						/>
					</div>
				</div>
			)}
			<div
				className="form-group row"
				hidden={invoiceType.value === "tickets" ? true : false}
			>
				<div className="col-sm-6">
					<input
						name="shipping"
						type="checkbox"
						checked={shipping}
						onChange={(e) => setShipping((prevValue) => !prevValue)}
					/>
					<label>&nbsp;Shipping Fee</label>
				</div>
			</div>
			{shipping && (
				<div
					className="form-group row"
					hidden={invoiceType.value === "tickets" ? true : false}
				>
					<div className="col-sm-4 d-flex justify-content-center">
						<input
							name="shippingGlobal"
							type="checkbox"
							checked={shippingGlobal}
							onChange={(e) => setShippingGlobal((prevValue) => !prevValue)}
						/>
						<label className="mt-auto mb-auto">&nbsp;Apply To Global</label>
					</div>
					<div className="col-sm-8">
						<label className="text-muted">Fee</label>
						<input
							name="shipping"
							type="number"
							className="form-control"
							value={shippingRate}
							onChange={(e) => {
								setShippingRate(e.target.value);
								shipRef.current = e.target.value ? e.target.value : 0;
								calculateTax();
							}}
						/>
					</div>
				</div>
			)}
			{franchise !== "Castle" && (
				<div
					className="form-group row"
					hidden={invoiceType.value === "tickets" ? true : false}
				>
					<div className="col-sm-6">
						<input
							name="timeSurcharge"
							type="checkbox"
							checked={timeSurcharge}
							onChange={(e) => setTimeSurcharge((prevValue) => !prevValue)}
						/>
						<label>&nbsp;Time Surcharge</label>
					</div>
				</div>
			)}
			{timeSurcharge && (
				<div
					className="form-group row"
					hidden={invoiceType.value === "tickets" ? true : false}
				>
					<div className="col-sm-4 d-flex justify-content-center">
						<input
							name="timeSurchargeGlobal"
							type="checkbox"
							checked={timeSurchargeGlobal}
							onChange={(e) =>
								setTimeSurchargeGlobal((prevValue) => !prevValue)
							}
						/>
						<label className="mt-auto mb-auto">&nbsp;Apply To Global</label>
					</div>
					<div className="col-sm-8">
						<label className="text-muted">Fee</label>
						<input
							name="timeSurchargeFee"
							type="number"
							className="form-control"
							value={timeSurchargeFee}
							onChange={(e) => {
								setTimeSurchargeFee(e.target.value);
								timeRef.current = e.target.value ? e.target.value : 0;
								calculateTax();
							}}
						/>
					</div>
				</div>
			)}
			{franchise !== "Castle" && (
				<div
					className="form-group row"
					hidden={invoiceType.value === "tickets" ? true : false}
				>
					<div className="col-sm-6">
						<input
							name="lightSurcharge"
							type="checkbox"
							checked={lightSurcharge}
							onChange={(e) => setLightSurcharge((prevValue) => !prevValue)}
						/>
						<label>&nbsp;Light Vehicle Surcharge</label>
					</div>
				</div>
			)}
			{lightSurcharge && (
				<div
					className="form-group row"
					hidden={invoiceType.value === "tickets" ? true : false}
				>
					<div className="col-sm-4 d-flex justify-content-center">
						<input
							name="lightSurchargeGlobal"
							type="checkbox"
							checked={lightSurchargeGlobal}
							onChange={(e) =>
								setLightSurchargeGlobal((prevValue) => !prevValue)
							}
						/>
						<label className="mt-auto mb-auto">&nbsp;Apply To Global</label>
					</div>
					<div className="col-sm-8">
						<label className="text-muted">Fee</label>
						<input
							name="lightSurchargeFee"
							type="number"
							className="form-control"
							value={lightSurchargeFee}
							onChange={(e) => {
								setLightSurchargeFee(e.target.value);
								lightRef.current = e.target.value ? e.target.value : 0;
								calculateTax();
							}}
						/>
					</div>
				</div>
			)}
			{franchise !== "Castle" && (
				<div
					className="form-group row"
					hidden={invoiceType.value === "tickets" ? true : false}
				>
					<div className="col-sm-6">
						<input
							name="iceSurcharge"
							type="checkbox"
							checked={iceSurcharge}
							onChange={(e) => setIceSurcharge((prevValue) => !prevValue)}
						/>
						<label>&nbsp;Ice Surcharge</label>
					</div>
				</div>
			)}
			{iceSurcharge && (
				<div
					className="form-group row"
					hidden={invoiceType.value === "tickets" ? true : false}
				>
					<div className="col-sm-4 d-flex justify-content-center">
						<input
							name="iceSurchargeGlobal"
							type="checkbox"
							checked={iceSurchargeGlobal}
							onChange={(e) => setIceSurchargeGlobal((prevValue) => !prevValue)}
						/>
						<label className="mt-auto mb-auto">&nbsp;Apply To Global</label>
					</div>
					<div className="col-sm-8">
						<label className="text-muted">Fee</label>
						<input
							name="iceSurchargeFee"
							type="number"
							className="form-control"
							value={iceSurchargeFee}
							onChange={(e) => {
								setIceSurchargeFee(e.target.value);
								iceRef.current = e.target.value ? e.target.value : 0;
								calculateTax();
							}}
						/>
					</div>
				</div>
			)}
			{franchise !== "Castle" && (
				<div
					className="form-group row"
					hidden={invoiceType.value === "tickets" ? true : false}
				>
					<div className="col-sm-6">
						<input
							name="plantStandBy"
							type="checkbox"
							checked={plantStandBy}
							onChange={(e) => setPlantStandBy((prevValue) => !prevValue)}
						/>
						<label>&nbsp;Plant Stand-By Fee</label>
					</div>
				</div>
			)}
			{plantStandBy && (
				<div
					className="form-group row"
					hidden={invoiceType.value === "tickets" ? true : false}
				>
					<div className="col-sm-4 d-flex justify-content-center">
						<input
							name="plantStandByGlobal"
							type="checkbox"
							checked={plantStandByGlobal}
							onChange={(e) => setPlantStandByGlobal((prevValue) => !prevValue)}
						/>
						<label className="mt-auto mb-auto">&nbsp;Apply To Global</label>
					</div>
					<div className="col-sm-8">
						<label className="text-muted">Fee</label>
						<input
							name="plantStandByFee"
							type="number"
							className="form-control"
							value={plantStandByFee}
							onChange={(e) => {
								setPlantStandByFee(e.target.value);
								plantRef.current = e.target.value ? e.target.value : 0;
								calculateTax();
							}}
						/>
					</div>
				</div>
			)}
			{franchise !== "Castle" && (
				<div
					className="form-group row"
					hidden={invoiceType.value === "tickets" ? true : false}
				>
					<div className="col-sm-6">
						<input
							name="environmentalChargePerLoad"
							type="checkbox"
							checked={environmentalChargePerLoad}
							onChange={(e) =>
								setEnvironmentalChargePerLoad((prevValue) => !prevValue)
							}
						/>
						<label>&nbsp;Environmental Charge Per Load</label>
					</div>
				</div>
			)}
			{environmentalChargePerLoad && (
				<div
					className="form-group row"
					hidden={invoiceType.value === "tickets" ? true : false}
				>
					<div className="col-sm-4 d-flex justify-content-center">
						<input
							name="environmentalChargePerLoadGlobal"
							type="checkbox"
							checked={environmentalChargePerLoadGlobal}
							onChange={(e) =>
								setEnvironmentalChargePerLoadGlobal((prevValue) => !prevValue)
							}
						/>
						<label className="mt-auto mb-auto">&nbsp;Apply To Global</label>
					</div>
					<div className="col-sm-8">
						<label className="text-muted">Fee</label>
						<input
							name="environmentalChargePerLoadFee"
							type="number"
							className="form-control"
							value={environmentalChargePerLoadFee}
							onChange={(e) => {
								setEnvironmentalChargePerLoadFee(e.target.value);
								environmentRef.current = e.target.value ? e.target.value : 0;
								calculateTax();
							}}
						/>
					</div>
				</div>
			)}
			{franchise === "Castle" && (
				<div
					className="form-group row"
					hidden={invoiceType.value === "tickets" ? true : false}
				>
					<div className="col-sm-6">
						<input
							name="readyMixTruckRentalService"
							type="checkbox"
							checked={readyMixTruckRentalService}
							onChange={(e) =>
								setReadyMixTruckRentalService((prevValue) => !prevValue)
							}
						/>
						<label>&nbsp;Ready Mix Truck Rental Service</label>
					</div>
				</div>
			)}
			{readyMixTruckRentalService && (
				<div
					className="form-group row"
					hidden={invoiceType.value === "tickets" ? true : false}
				>
					<div className="col-sm-4 d-flex justify-content-center">
						<input
							name="readyMixTruckRentalServiceGlobal"
							type="checkbox"
							checked={readyMixTruckRentalServiceGlobal}
							onChange={(e) =>
								setReadyMixTruckRentalServiceGlobal((prevValue) => !prevValue)
							}
						/>
						<label className="mt-auto mb-auto">&nbsp;Apply To Global</label>
					</div>
					<div className="col-sm-8">
						<label className="text-muted">Fee</label>
						<input
							name="readyMixTruckRentalServiceFee"
							type="number"
							className="form-control"
							value={readyMixTruckRentalServiceFee}
							onChange={(e) => {
								setReadyMixTruckRentalServiceFee(e.target.value);
								readyMixTruckRef.current = e.target.value ? e.target.value : 0;
								calculateTax();
							}}
						/>
					</div>
				</div>
			)}
			{franchise === "Castle" && (
				<div
					className="form-group row"
					hidden={invoiceType.value === "tickets" ? true : false}
				>
					<div className="col-sm-6">
						<input
							name="readyMixDriver"
							type="checkbox"
							checked={readyMixDriver}
							onChange={(e) => setReadyMixDriver((prevValue) => !prevValue)}
						/>
						<label>&nbsp;Ready Mix Driver</label>
					</div>
				</div>
			)}
			{readyMixDriver && (
				<div
					className="form-group row"
					hidden={invoiceType.value === "tickets" ? true : false}
				>
					<div className="col-sm-4 d-flex justify-content-center">
						<input
							name="readyMixDriverGlobal"
							type="checkbox"
							checked={readyMixDriverGlobal}
							onChange={(e) =>
								setReadyMixDriverGlobal((prevValue) => !prevValue)
							}
						/>
						<label className="mt-auto mb-auto">&nbsp;Apply To Global</label>
					</div>
					<div className="col-sm-8">
						<label className="text-muted">Fee</label>
						<input
							name="readyMixDriverFee"
							type="number"
							className="form-control"
							value={readyMixDriverFee}
							onChange={(e) => {
								setReadyMixDriverFee(e.target.value);
								readyMixDriverRef.current = e.target.value ? e.target.value : 0;
								calculateTax();
							}}
						/>
					</div>
				</div>
			)}
			<div
				className="form-group row"
				hidden={invoiceType.value === "tickets" ? true : false}
			>
				<div className="col-sm-6">
					<input
						name="cardPayment"
						type="checkbox"
						checked={isCreditCardPayment}
						onChange={(e) => {
							setIsCreditCardPayment((prevValue) => !prevValue);
						}}
					/>
					<label>&nbsp;Credit Card Payment</label>
				</div>
				{isCreditCardPayment && (
					<div className="col-sm-6">
						<label className="text-muted">Credit Card Fee (%)</label>
						<input
							name="CreditCardFee"
							type="number"
							className="form-control"
							value={creditCardFee}
							onChange={(e) => {
								setCreditCardFee(e.target.value);
								creditRef.current = e.target.value ? e.target.value : 0;
								calculateTax();
							}}
						/>
					</div>
				)}
			</div>
			<div className="form-group">
				<input
					name="applyDiscount"
					type="checkbox"
					checked={applyDiscount}
					onChange={(e) => {
						setApplyDiscount((prevValue) => !prevValue);
						invoiceType.value === "total" ? calculateTax() : calculateTotals();
					}}
				/>
				<label>&nbsp;Apply Discount</label>
			</div>
			{applyDiscount && (
				<div className="form-group row">
					<div className="col-sm-5">
						<label className="text-muted">Discount Type</label>
						<DiscountPicker action={onChangeDiscount} value={discountType} />
					</div>
					<div className="col-sm-3">
						<label className="text-muted">Discount</label>
						<input
							name="discount"
							type="number"
							className="form-control"
							value={discount}
							onChange={(e) => {
								setDiscount(e.target.value);
								discountRef.current = e.target.value ? e.target.value : 0;
								calculateTax();
							}}
						/>
					</div>
					<div className="col-sm-4">
						<label className="text-muted">Discount Reason</label>
						<input
							name="discountReason"
							type="text"
							className="form-control"
							value={discountReason}
							onChange={(e) => setDiscountReason(e.target.value)}
						/>
					</div>
				</div>
			)}
			<div
				className="form-group"
				hidden={invoiceType.value === "tickets" ? true : false}
			>
				<input
					name="factoring"
					type="checkbox"
					checked={factoring}
					onChange={(e) => setFactoring(!factoring)}
				/>
				<label>&nbsp;Requiere Factoring</label>
			</div>
			<div
				className="form-group row"
				hidden={invoiceType.value === "tickets" ? true : false}
			>
				<div className="col-sm-6">
					<input
						name="color"
						type="checkbox"
						checked={color}
						onChange={(e) => {
							setColor((prevValue) => !prevValue);
						}}
					/>
					<label>&nbsp;Color</label>
				</div>
			</div>
			{color && (
				<div
					className="form-group row"
					hidden={invoiceType.value === "tickets" ? true : false}
				>
					<div className="col-sm-4 d-flex justify-content-center">
						<input
							name="colorGlobal"
							type="checkbox"
							checked={colorGlobal}
							onChange={(e) => setColorGlobal((prevValue) => !prevValue)}
						/>
						<label className="mt-auto mb-auto">&nbsp;Apply To Global</label>
					</div>
					<div className="col-sm-8">
						<label className="text-muted">Fee</label>
						<input
							name="Color"
							type="number"
							className="form-control"
							value={colorTicket}
							onChange={(e) => {
								setColorTicket(e.target.value);
								colorRef.current = e.target.value ? e.target.value : 0;
								calculateTax();
							}}
						/>
					</div>
				</div>
			)}
			<div
				className="form-group row"
				hidden={invoiceType.value === "tickets" ? true : false}
			>
				<div className="col-sm-6">
					<input
						name="fiber"
						type="checkbox"
						checked={fiber}
						onChange={() => setFiber((prevValue) => !prevValue)}
					/>
					<label>&nbsp;Fiber</label>
				</div>
			</div>
			{fiber && (
				<div
					className="form-group row"
					hidden={invoiceType.value === "tickets" ? true : false}
				>
					<div className="col-sm-4 d-flex justify-content-center">
						<input
							name="fiberGlobal"
							type="checkbox"
							checked={fiberGlobal}
							onChange={(e) => setFiberGlobal((prevValue) => !prevValue)}
						/>
						<label className="mt-auto mb-auto">&nbsp;Apply To Global</label>
					</div>
					<div className="col-sm-8">
						<label className="text-muted">Fee</label>
						<input
							name="Fiber"
							type="number"
							className="form-control"
							value={fiberBags}
							onChange={(e) => {
								setFiberBags(e.target.value);
								fiberRef.current = e.target.value ? e.target.value : 0;
								calculateTax();
							}}
						/>
					</div>
				</div>
			)}
			<div
				className="form-group row"
				hidden={invoiceType.value === "tickets" ? true : false}
			>
				<div className="col-sm-6">
					<input
						name="size"
						type="checkbox"
						checked={size}
						onChange={() => setSize((prevValue) => !prevValue)}
					/>
					<label>&nbsp;Size</label>
				</div>
			</div>
			{size && (
				<div
					className="form-group row"
					hidden={invoiceType.value === "tickets" ? true : false}
				>
					<div className="col-sm-4 d-flex justify-content-center">
						<input
							name="sizeGlobal"
							type="checkbox"
							checked={sizeGlobal}
							onChange={(e) => setSizeGlobal((prevValue) => !prevValue)}
						/>
						<label className="mt-auto mb-auto">&nbsp;Apply To Global</label>
					</div>
					<div className="col-sm-8">
						<label className="text-muted">Fee</label>
						<input
							name="Size"
							type="number"
							className="form-control"
							value={sizeBags}
							onChange={(e) => {
								setSizeBags(e.target.value);
								sizeRef.current = e.target.value ? e.target.value : 0;
								calculateTax();
							}}
						/>
					</div>
				</div>
			)}
			<div
				className="form-group row"
				hidden={invoiceType.value === "tickets" ? true : false}
			>
				<div className="col-sm-6">
					<input
						name="miscelaneos"
						type="checkbox"
						checked={miscelaneos}
						onChange={() => setMiscelaneos((prevValue) => !prevValue)}
					/>
					<label>&nbsp;Miscelaneos</label>
				</div>
			</div>
			{miscelaneos && (
				<div
					className="form-group row"
					hidden={invoiceType.value === "tickets" ? true : false}
				>
					<div className="col-sm-4 d-flex justify-content-center">
						<input
							name="miscelaneosGlobal"
							type="checkbox"
							checked={miscelaneosGlobal}
							onChange={(e) => setMiscelaneosGlobal((prevValue) => !prevValue)}
						/>
						<label className="mt-auto mb-auto">&nbsp;Apply To Global</label>
					</div>
					<div className="col-sm-4">
						<label className="text-muted">Fee</label>
						<input
							name="Miscelaneos"
							type="number"
							className="form-control"
							value={miscelaneosFee}
							onChange={(e) => {
								setMiscelaneosFee(e.target.value);
								miscelaneosRef.current = e.target.value ? e.target.value : 0;
								calculateTax();
							}}
						/>
					</div>
					<div className="col-sm-4">
						<label className="text-muted">Miscelaneos Reason</label>
						<input
							name="miscelaneosReason"
							type="text"
							className="form-control"
							value={miscelaneosReason}
							onChange={(e) => setMiscelaneosReason(e.target.value)}
						/>
					</div>
				</div>
			)}
			{franchise !== "Castle" && (
				<div
					className="form-group row"
					hidden={invoiceType.value === "tickets" ? true : false}
				>
					<div className="col-sm-6">
						<input
							name="energyConsumption"
							type="checkbox"
							checked={energyConsumption}
							onChange={() => setEnergyConsumption((prevValue) => !prevValue)}
						/>
						<label>&nbsp;Energy Consumption</label>
					</div>
				</div>
			)}
			{energyConsumption && (
				<div
					className="form-group row"
					hidden={invoiceType.value === "tickets" ? true : false}
				>
					<div className="col-sm-4 d-flex justify-content-center">
						<input
							name="energyConsumptionGlobal"
							type="checkbox"
							checked={energyConsumptionGlobal}
							onChange={(e) =>
								setEnergyConsumptionGlobal((prevValue) => !prevValue)
							}
						/>
						<label className="mt-auto mb-auto">&nbsp;Apply To Global</label>
					</div>
					<div className="col-sm-8">
						<label className="text-muted">Fee</label>
						<input
							name="Energy Consumption"
							type="number"
							className="form-control"
							value={energyConsumptionFee}
							onChange={(e) => {
								setEnergyConsumptionFee(e.target.value);
								energyConsumptionRef.current = e.target.value
									? e.target.value
									: 0;
								calculateTax();
							}}
						/>
					</div>
				</div>
			)}
			<div>
				<LoadList
					list={loadList}
					setList={setLoadList}
					calculateTotals={calculateTotals}
					isTotal={invoiceType.value === "total" ? true : false}
				/>
			</div>
			<div className="form-group row">
				<div className="col-sm-2">
					<label className="text-muted">Fuel Surcharge</label>
					<input
						type="text"
						style={{ textAlign: "right" }}
						className="form-control"
						readOnly
						value={
							invoiceType.value === "tickets"
								? toCurrency(totalsPerTicket.current.tripCharge, 2)
								: fuelSurcharge
									? fuelSurchargeGlobal
										? toCurrency(fuelRef.current * 1, 2)
										: toCurrency(trips * fuelRef.current, 2)
									: toCurrency(0, 2)
						}
					/>
				</div>
				{franchise !== "Castle" && (
					<div className="col-sm-2">
						<label className="text-muted">Time Surcharge</label>
						<input
							type="text"
							style={{ textAlign: "right" }}
							className="form-control"
							readOnly
							value={
								invoiceType.value === "tickets"
									? toCurrency(totalsPerTicket.current.timeSurchargeFee, 2)
									: timeSurcharge
										? timeSurchargeGlobal
											? toCurrency(timeRef.current * 1, 2)
											: toCurrency(trips * timeRef.current, 2)
										: toCurrency(0, 2)
							}
						/>
					</div>
				)}
				{franchise !== "Castle" && (
					<div className="col-sm-2">
						<label className="text-muted">Light Surcharge</label>
						<input
							type="text"
							style={{ textAlign: "right" }}
							className="form-control"
							readOnly
							value={
								invoiceType.value === "tickets"
									? toCurrency(totalsPerTicket.current.lightSurchargeFee, 2)
									: lightSurcharge
										? lightSurchargeGlobal
											? toCurrency(lightRef.current * 1, 2)
											: toCurrency(trips * lightRef.current, 2)
										: toCurrency(0, 2)
							}
						/>
					</div>
				)}
				{franchise !== "Castle" && (
					<div className="col-sm-2">
						<label className="text-muted">Ice Surcharge</label>
						<input
							type="text"
							style={{ textAlign: "right" }}
							className="form-control"
							readOnly
							value={
								invoiceType.value === "tickets"
									? toCurrency(totalsPerTicket.current.iceSurchargeFee, 2)
									: iceSurcharge
										? iceSurchargeGlobal
											? toCurrency(iceRef.current * 1, 2)
											: toCurrency(trips * iceRef.current, 2)
										: toCurrency(0, 2)
							}
						/>
					</div>
				)}
				{franchise !== "Castle" && (
					<div className="col-sm-2">
						<label className="text-muted">Plant Stand-By Fee</label>
						<input
							type="text"
							style={{ textAlign: "right" }}
							className="form-control"
							readOnly
							value={
								invoiceType.value === "tickets"
									? toCurrency(totalsPerTicket.current.plantStandByFee, 2)
									: plantStandBy
										? plantStandByGlobal
											? toCurrency(plantRef.current * 1, 2)
											: toCurrency(trips * plantRef.current, 2)
										: toCurrency(0, 2)
							}
						/>
					</div>
				)}
				{franchise !== "Castle" && (
					<div className="col-sm-2">
						<label className="text-muted">Environmental Charge Per Load</label>
						<input
							type="text"
							style={{ textAlign: "right" }}
							className="form-control"
							readOnly
							value={
								invoiceType.value === "tickets"
									? toCurrency(
											totalsPerTicket.current.environmentalChargePerLoadFee,
											2,
										)
									: environmentalChargePerLoad
										? environmentalChargePerLoadGlobal
											? toCurrency(environmentRef.current * 1, 2)
											: toCurrency(trips * environmentRef.current, 2)
										: toCurrency(0, 2)
							}
						/>
					</div>
				)}
				{franchise === "Castle" && (
					<div className="col-sm-2">
						<label className="text-muted">Ready Mix Truck Rental Service</label>
						<input
							type="text"
							style={{ textAlign: "right" }}
							className="form-control"
							readOnly
							value={
								invoiceType.value === "tickets"
									? toCurrency(
											totalsPerTicket.current.readyMixTruckRentalServiceFee,
											2,
										)
									: readyMixTruckRentalService
										? readyMixTruckRentalServiceGlobal
											? toCurrency(readyMixTruckRef.current * 1, 2)
											: toCurrency(trips * readyMixTruckRef.current, 2)
										: toCurrency(0, 2)
							}
						/>
					</div>
				)}
				{franchise === "Castle" && (
					<div className="col-sm-2">
						<label className="text-muted">Ready Mix Driver</label>
						<input
							type="text"
							style={{ textAlign: "right" }}
							className="form-control"
							readOnly
							value={
								invoiceType.value === "tickets"
									? toCurrency(totalsPerTicket.current.readyMixDriverFee, 2)
									: readyMixDriver
										? readyMixDriverGlobal
											? toCurrency(readyMixDriverRef.current * 1, 2)
											: toCurrency(trips * readyMixDriverRef.current, 2)
										: toCurrency(0, 2)
							}
						/>
					</div>
				)}
				<div className="col-sm-2">
					<label className="text-muted">Shipping Fee</label>
					<input
						type="text"
						style={{ textAlign: "right" }}
						className="form-control"
						readOnly
						value={
							invoiceType.value === "tickets"
								? toCurrency(totalsPerTicket.current.shippingFee, 2)
								: shipping
									? shippingGlobal
										? toCurrency(shipRef.current * 1, 2)
										: toCurrency(shipRef.current * trips, 2)
									: toCurrency(0, 2)
						}
					/>
				</div>
				<div className="col-sm-4">
					<label className="text-muted">Credit Card</label>
					<input
						type="text"
						style={{ textAlign: "right" }}
						className="form-control"
						readOnly
						value={
							isCreditCardPayment
								? toCurrency(creditCardCost, 2)
								: toCurrency(0, 2)
						}
					/>
				</div>
			</div>
			<div className="form-group row">
				<div className="col-sm-2">
					<label className="text-muted">Color</label>
					<input
						type="text"
						style={{ textAlign: "right" }}
						className="form-control"
						readOnly
						value={
							invoiceType.value === "tickets"
								? toCurrency(totalsPerTicket.current.colorFee, 2)
								: color
									? colorGlobal
										? toCurrency(colorRef.current * 1, 2)
										: toCurrency(colorRef.current * trips, 2)
									: toCurrency(0, 2)
						}
					/>
				</div>
				<div className="col-sm-2">
					<label className="text-muted">Fiber</label>
					<input
						type="text"
						style={{ textAlign: "right" }}
						className="form-control"
						readOnly
						value={
							invoiceType.value === "tickets"
								? toCurrency(totalsPerTicket.current.fiberFee, 2)
								: fiber
									? fiberGlobal
										? toCurrency(fiberRef.current * 1, 2)
										: toCurrency(fiberRef.current * trips, 2)
									: toCurrency(0, 2)
						}
					/>
				</div>
				<div className="col-sm-2">
					<label className="text-muted">Size</label>
					<input
						type="text"
						style={{ textAlign: "right" }}
						className="form-control"
						readOnly
						value={
							invoiceType.value === "tickets"
								? toCurrency(totalsPerTicket.current.sizeFee, 2)
								: size
									? sizeGlobal
										? toCurrency(sizeRef.current * 1, 2)
										: toCurrency(sizeRef.current * trips, 2)
									: toCurrency(0, 2)
						}
					/>
				</div>
				<div className="col-sm-2">
					<label className="text-muted">Miscelaneos</label>
					<input
						type="text"
						style={{ textAlign: "right" }}
						className="form-control"
						readOnly
						value={
							invoiceType.value === "tickets"
								? toCurrency(totalsPerTicket.current.miscelaneosFee, 2)
								: miscelaneos
									? miscelaneosGlobal
										? toCurrency(miscelaneosRef.current * 1, 2)
										: toCurrency(miscelaneosRef.current * trips, 2)
									: toCurrency(0, 2)
						}
					/>
				</div>
				{franchise !== "Castle" && (
					<div className="col-sm-4">
						<label className="text-muted">Energy Consumption</label>
						<input
							type="text"
							style={{ textAlign: "right" }}
							className="form-control"
							readOnly
							value={
								invoiceType.value === "tickets"
									? toCurrency(totalsPerTicket.current.energyConsumptionFee, 2)
									: energyConsumption
										? energyConsumptionGlobal
											? toCurrency(energyConsumptionRef.current * 1, 2)
											: toCurrency(energyConsumptionRef.current * trips, 2)
										: toCurrency(0, 2)
							}
						/>
					</div>
				)}
			</div>
			<div className="form-group row">
				<div className="col-sm-3">
					<label className="text-muted">Subtotal</label>
					<input
						type="text"
						style={{ textAlign: "right" }}
						className="form-control"
						readOnly
						value={toCurrency(subtotal, 2)}
					/>
				</div>
				<div className="col-sm-3">
					<label className="text-muted">Discount</label>
					<input
						type="text"
						style={{ textAlign: "right" }}
						className="form-control"
						readOnly
						value={toCurrency(discountAmount, 2)}
					/>
				</div>
				<div className="col-sm-3">
					<label className="text-muted">Tax</label>
					<input
						type="text"
						style={{ textAlign: "right" }}
						className="form-control"
						readOnly
						value={toCurrency(taxAmount, 2)}
					/>
				</div>
				<div className="col-sm-3">
					<label className="text-muted">Total</label>
					<input
						type="text"
						style={{ textAlign: "right" }}
						className="form-control"
						readOnly
						value={toCurrency(invoiceTotal, 2)}
					/>
				</div>
			</div>
			<div className="form-group row">
				<div className="col-sm-6">
					<label className="text-muted">PO</label>
					<input
						type="text"
						className="form-control"
						name="po"
						value={po}
						placeholder="Purchase Order"
						onChange={(e) => setPO(e.target.value)}
					/>
				</div>
				<div className="col-sm-6">
					<label className="text-muted">Term</label>
					<input
						type="text"
						className="form-control"
						name="paymentTerm"
						value={paymentTerm}
						placeholder="Payment Term"
						readOnly
					/>
				</div>
			</div>
			<div className="my-2">
				<button className="btn btn-success" disabled={loading.current}>
					{loading.current ? "Loading..." : "Generate"}
				</button>{" "}
				{loading.current ? (
					<SpinnerButton type={"danger"} />
				) : (
					<button
						className="btn btn-danger"
						type="button"
						onClick={showEtickets}
					>
						Etickets
					</button>
				)}{" "}
				{loading.current ? (
					<SpinnerButton type={"primary"} />
				) : (
					<button
						className="btn btn-primary"
						type="button"
						onClick={copyTickets}
					>
						Copy Tickets
					</button>
				)}
			</div>
		</form>
	);

	const showEtickets = () => {
		const url = "/eticketsjob/" + jobId;
		history.push(url);
	};

	const copyTickets = () => {
		let textContent = "";
		loadList.map((i, index) => {
			if (index < loadList.length - 1) {
				textContent += i.deliveryTicket + ",";
			} else {
				textContent += i.deliveryTicket;
			}
		});

		navigator.clipboard.writeText(textContent);
	};

	return <>{InvoiceForm()}</>;
};

export default JobToInvoiceModal;
